export const CUSTOM_SHADOW_MIN_ANGLE = 0;
export const CUSTOM_SHADOW_MAX_ANGLE = 359;
